import React from 'react';
import {
  Dialog as PrimeDialog,
  DialogProps as PrimeDialogProps,
} from 'primereact/dialog';

interface GFNDialogProps extends Omit<PrimeDialogProps, 'style'> {
  /**
   * Custom test ID for testing
   */
  testId?: string;

  /**
   * Dialog size
   * @default 'md'
   */
  size?: 'sm' | 'md' | 'lg' | 'xl';

  /**
   * Additional CSS classes
   */
  className?: string;
}

/**
 * GFN Dialog Component
 */
const GFNDialog = React.forwardRef<any, GFNDialogProps>(
  (
    {
      testId,
      size = 'md',
      className = '',
      modal = true,
      draggable = false,
      ...restProps
    },
    ref
  ) => {
    const sizeMap = {
      sm: '30vw',
      md: '50vw',
      lg: '70vw',
      xl: '90vw',
    };

    return (
      <PrimeDialog
        ref={ref}
        style={{ width: sizeMap[size] }}
        modal={modal}
        draggable={draggable}
        className={className}
        data-testid={testId}
        {...restProps}
      />
    );
  }
);

GFNDialog.displayName = 'GFNDialog';

export default GFNDialog;
export { GFNDialog };